import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/financial/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/financial/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/financial/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/financial/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Right panel configuration
        const right = {
            type: 'wide',
            rows: [
                PlayersView, // Including PlayersView in the right panel
                RecordWithdrawalRequest, // Including RecordWithdrawalRequest in the right panel
                DetailsWithdrawalRequest, // Including DetailsWithdrawalRequest in the right panel
            ],
        };

        // Alternative right panel configuration for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordWithdrawalRequest, DetailsWithdrawalRequest], // Including components for smaller screens
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS class for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000', '10000'], // Options for page size
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('table').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('table').refresh(); // Refresh table
                            $$('table').scrollTo(0, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    animate: {
                        subtype: 'out', // Animation type
                    },
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'Excel Interbank' }, // Export to Interbank Excel option
                        { id: '3', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('table').getPager().config.size; // Get current page size
                            var page = $$('table').getPage(); // Get current page number
                            var first = size * page; // Calculate first index for export
                            var last = first + size - 1; // Calculate last index for export
                            if (value == 1) {
                                // If Excel export selected
                                var table = $$('table'); // Get the table instance
                                var originalTemplate = null;
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].id == 'RiskStatus') {
                                        if (!originalTemplate) {
                                            originalTemplate = table.config.columns[j].template;
                                        }

                                        table.config.columns[j].template = function (obj) {
                                            // Custom template for RiskStatus column
                                            if (obj.RiskStatus == 'A') {
                                                return 'Alto';
                                            } else if (obj.RiskStatus == 'M') {
                                                return 'Medio';
                                            } else if (obj.RiskStatus == 'B') {
                                                return 'Bajo';
                                            } else if (obj.RiskStatus == 'NC') {
                                                return 'No clasificado'
                                            }   else {
                                                return '';
                                            }
                                        };
                                    }
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Solicitudes de Retiro', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('table').getIndexById(obj.id) >= first &&
                                            $$('table').getIndexById(obj.id) <= last // Filter for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Solicitudes de Retiro', // Filename for export
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                        ch1: true,
                                    },
                                    footer: false,
                                }).then(() => {

                                    // Restaurar template original
                                    for (var j = 0; j < table.config.columns.length; j++) {
                                        if (table.config.columns[j].id == 'RiskStatus' && originalTemplate) {
                                            table.config.columns[j].template = originalTemplate;
                                        }
                                    }

                                    table.refreshColumns(); // importante para que vuelva a pintar
                                });
                            } else {
                                if (value == 2) {
                                    // If Interbank Excel export selected
                                    var table = $$('table'); // Get the table instance
                                    var originalTemplate = null;
                                    for (var j = 0; j < table.config.columns.length; j++) {
                                        if (table.config.columns[j].id == 'RiskStatus') {
                                            if (!originalTemplate) {
                                                originalTemplate = table.config.columns[j].template;
                                            }

                                            table.config.columns[j].template = function (obj) {
                                                // Custom template for RiskStatus column
                                                if (obj.RiskStatus == 'A') {
                                                    return 'Alto';
                                                } else if (obj.RiskStatus == 'M') {
                                                    return 'Medio';
                                                } else if (obj.RiskStatus == 'B') {
                                                    return 'Bajo';
                                                } else if (obj.RiskStatus == 'NC') {
                                                    return 'No clasificado'
                                                }   else {
                                                    return '';
                                                }
                                            };
                                        }
                                        if (table.config.columns[j].exportType) {
                                            delete table.config.columns[j].format; // Remove format for export
                                        }
                                    }
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Solicitudes de Retiro Interbank', // Report name
                                            TypeReport: 'Excel Interbank', // Report type
                                        },
                                    ]);
                                    webix.toExcel(table, {
                                        // Export to Interbank Excel
                                        filter: function (obj) {
                                            return (
                                                $$('table').getIndexById(obj.id) >= first &&
                                                $$('table').getIndexById(obj.id) <= last // Filter for export
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Solicitudes de Retiro Interbank', // Filename for export
                                        columns: {
                                            TypeDocument: {
                                                header: _('Tipo de Documento'), // Column header
                                                width: 160,
                                            },
                                            Identification: {
                                                header: _('Número de Documento'), // Column header
                                                width: 160,
                                            },
                                            ClientName: {
                                                header: _('Nombre del Beneficiario'), // Column header
                                                width: 250,
                                                template: function (obj) {
                                                    // Template for client name
                                                    var array = obj.ClientName.split(' ');
                                                    return array[2] + ';' + array[3] + ';' + array[0] + ';' + array[1];
                                                },
                                            },
                                            '': { header: '', width: 200 }, // Empty column
                                            MobilePhone: {
                                                header: _('Celular'), // Column header
                                                width: 200,
                                            },
                                            WayPay: {
                                                header: _('Tipo de Abono'), // Column header
                                                width: 300,
                                            },
                                            TypeAccount: {
                                                header: '1Tipo de Cuenta', // Column header
                                                width: 180,
                                            },
                                            Currency: {
                                                header: 'Moneda de Cuenta', // Column header
                                                width: 200,
                                            },
                                            AccountBank: {
                                                header: 'N° Cuenta', // Column header
                                                width: 200,
                                            },
                                            Currency2: {
                                                header: 'Moneda de Abono', // Column header
                                                width: 200,
                                                template: function (obj) {
                                                    // Template for currency
                                                    return obj.Currency;
                                                },
                                            },
                                            Amount: {
                                                header: 'Monto de Abono', // Column header
                                                width: 200,
                                            },
                                        },
                                        footer: false,
                                    }).then(() => {

                                        // Restaurar template original
                                        for (var j = 0; j < table.config.columns.length; j++) {
                                            if (table.config.columns[j].id == 'RiskStatus' && originalTemplate) {
                                                table.config.columns[j].template = originalTemplate;
                                            }
                                        }

                                        table.refreshColumns(); // importante para que vuelva a pintar
                                    });
                                } else {
                                    if (value == 3) {
                                        var table = $$('table'); // Get the table instance
                                        var originalTemplate = null;
                                        for (var j = 0; j < table.config.columns.length; j++) {
                                            if (table.config.columns[j].id == 'RiskStatus') {
                                                if (!originalTemplate) {
                                                    originalTemplate = table.config.columns[j].template;
                                                }

                                                table.config.columns[j].template = function (obj) {
                                                    // Custom template for RiskStatus column
                                                    if (obj.RiskStatus == 'A') {
                                                        return 'Alto';
                                                    } else if (obj.RiskStatus == 'M') {
                                                        return 'Medio';
                                                    } else if (obj.RiskStatus == 'B') {
                                                        return 'Bajo';
                                                    } else if (obj.RiskStatus == 'NC') {
                                                        return 'No clasificado'
                                                    }   else {
                                                        return '';
                                                    }
                                                };
                                            }
                                            if (table.config.columns[j].exportType) {
                                                delete table.config.columns[j].format; // Remove format for export
                                            }
                                        }
                                        // If PDF export selected
                                        this.app.callEvent('export:data', [
                                            {
                                                NameReport:
                                                    ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                                    'Solicitudes de Retiro', // Report name
                                                TypeReport: 'PDF', // Report type
                                            },
                                        ]);
                                        webix.toPDF($$('table'), {
                                            // Export to PDF
                                            filter: function (obj) {
                                                return (
                                                    $$('table').getIndexById(obj.id) >= first &&
                                                    $$('table').getIndexById(obj.id) <= last // Filter for export
                                                );
                                            },
                                            filename:
                                                'Virtualsoft - ' +
                                                new Date()
                                                    .toLocaleString('en-GB', {
                                                        hour12: true,
                                                    })
                                                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                    .replace(/[\/:]/g, '_')
                                                    .toUpperCase() +
                                                ' - ' +
                                                ($$('table').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Solicitudes de Retiro', // Filename for export
                                            autowidth: true,
                                            ignore: {
                                                detailTittle: true,
                                                ActionTittle: true,
                                            },
                                            footer: false,
                                        }).then(() => {

                                            // Restaurar template original
                                            for (var j = 0; j < table.config.columns.length; j++) {
                                                if (table.config.columns[j].id == 'RiskStatus' && originalTemplate) {
                                                    table.config.columns[j].template = originalTemplate;
                                                }
                                            }

                                            table.refreshColumns(); // importante para que vuelva a pintar
                                        });
                                    }
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind context to the function
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply theme
                    elements: [
                        { view: 'label', label: _('Solicitudes de Retiro') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon', // Icon for search
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event for search button
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterWithdrawalRequests, // Including filter component
                TableWithdrawalRequest, // Including table component
                toolbar, // Including toolbar
            ],
        };

        // Advanced details accordion configuration
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details section
            ],
        };

        // Alternative advanced details accordion for smaller screens
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right, // Advanced details section
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $$(function () {
                                height =
                                    $$('.scrolling > .webix_scroll_cont').height() -
                                    $$('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $$('.scrolling > .webix_scroll_cont').height() -
                                        $$('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Recalculate height for scrolling
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling', // CSS class for styling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        { id: 'res', view: 'resizer' }, // Resizer between panels
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use avanc for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screens
                $$('res').hide(); // Hide resizer
                var childs = $$('toolbar').getChildViews(); // Get child views of toolbar
                $$('toolbar').removeView(childs[2]); // Remove export dropdown from toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screens
                $$('button-search').hide(); // Hide search button
            }
        });
    }
}

// FILE DOCUMENTED
